<template>
  <div class="page-content loss-prevention">
    <div class="row">
      <div class="col-12">
        <loss-prevention-alerts />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { nextTick, onMounted, defineAsyncComponent } from 'vue';
import { useRoute } from 'vue-router';

import util from '@/Utils/util';

const LossPreventionAlerts = defineAsyncComponent(() => import('./LossPrevention/LossPreventionAlerts.vue') as any);

onMounted(async () => {
  const route = useRoute();
  const { hash } = route;

  await nextTick();
  util.moveScrollComponent(hash);
});
</script>
